import { render } from "./UserDashboardNew.vue?vue&type=template&id=af372bf4&scoped=true"
import script from "./UserDashboardNew.vue?vue&type=script&lang=js"
export * from "./UserDashboardNew.vue?vue&type=script&lang=js"

import "./UserDashboardNew.vue?vue&type=style&index=0&id=af372bf4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af372bf4"]])

export default __exports__